import React from 'react';
import { BodyText, Heading } from '../../atoms';
import { PageHeaderSize } from '../PageHeader/type';
import { PageHeaderSubtitleWrapper } from './PageHeaderSubtitle.styles';

export type PageHeaderTitleProps = {
  /**
   * Subtitle text
   */
  subtitle: string;
  /**
   * Text size
   */
  size: PageHeaderSize;
};

const PageHeaderSubtitle = ({ subtitle, size }: PageHeaderTitleProps) => {
  return (
    <PageHeaderSubtitleWrapper>
      <>
        {size === 'small' ? (
          <BodyText variant="body2" color="inherit">
            {subtitle}
          </BodyText>
        ) : (
          <Heading variant="h3" color="inherit">
            {subtitle}
          </Heading>
        )}
      </>
    </PageHeaderSubtitleWrapper>
  );
};

export default PageHeaderSubtitle;
